import React from 'react'
import {Grid, Container, Stack, AppBar, IconButton} from '@mui/material'
import WbButton from '../../components/common/WbButton'
import Zone from './Zone'
import unifiedLogout from '../../utils/unifiedLogout'

export default function SelectZone() {

  return (
    <>
      <AppBar className="header">
        <Container maxWidth="xxl">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <div className="logo">
              <span>Welbee</span>
            </div>
            <div>
              <nav>
                <WbButton
                  onClick={() => {
                    unifiedLogout()
                  }}
                  CustomButtonText="Logout"
                />                  
              </nav>
            </div>
          </Stack>
        </Container>
      </AppBar>
      <div className="main-container">
        <Container maxWidth="lg">
            <Grid container mt={4}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <h1>My Safe Space</h1>               
                </Grid>                
            </Grid> 
            
            <Grid container mt={6} mb={6}>
                <Grid item lg={12} md={12} sm={12} xs={12} textAlign="center">
                    <h1 className='select-staff-heading'>How are you feeling today?</h1>               
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={8} mt={2} mx={"auto"}>
                    <Zone />                                        
                </Grid>
            </Grid>
            
        </Container>
      </div>
    </>    
  )
}
